export const getWordCount = (text: string) => {
  if (!text || typeof text !== 'string') {
    return undefined;
  }
  const wordCount = text?.match(/(\w+)/g)?.length ?? 0;
  return wordCount;
};
